const HomePage = () => {
    return (
        <div className="card panelFull text-center">
            <p>Wybierz, serwer aby kontynować</p>
            <p>Jeśli nie widzisz serwerów, poproś administrację o uprawnienia</p>
        </div>
    )
}

export default HomePage;